<template>
  <div class="meal-content">
    <el-row>
      <el-col :span="5" class="meal-left">
        <div>
          <el-avatar :size="45" :src="sex=='女'?'static/img/huanzhenv.png':'static/img/huanzhenan.png'"></el-avatar>
        </div>
      </el-col>
      <el-col :span="17">
        <div class="meal-name">{{name}}</div>
        <div class="meal-describe">{{describe}}</div>
        <div class="meal-price">￥{{price}}</div>
      </el-col>
      <el-col :span="2" class="more">
        <i class="el-icon-arrow-right"></i>
      </el-col>
    </el-row>
  </div>
</template>

<script>
    export default {
      props:{
        //性别
        sex:{
          type:String
        },
        //套餐名称
        name:{
          type:String,
          default:"妇科专项体检套餐(2020年)"
        },
        //套餐描述
        describe:{
          type:String,
          default:"体检报告领取时间：体检结束后8天"
        },
        //套餐价格
        price:{
          type:String,
          default:"764"
        },
      }
    }
</script>

<style scoped>
  .meal-content{
    width: 100%;
    height: 1.5rem;
    background-color: #ffffff;
    border-bottom: 1px #dddddd solid;
  }
  .meal-left{
    height: 1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .meal-name{
    font-size: .3rem;
    height: .5rem;
    line-height: .75rem;
  }
  .meal-describe{
    font-size: .26rem;
    height: .5rem;
    line-height: .6rem;
    color: #999;
  }
  .meal-price{
    font-size: .28rem;
    color: #409eff;
    height: .4rem;
    line-height: .42rem;
  }
  .more{
    line-height: 1.6rem;
    font-size: .36rem;
    padding-right: .2rem;
    color: #8a8a8a;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Meal.vue